export enum Region {
  FLANDERS = 'Flanders',
  BRUSSELS = 'Brussels',
  WALLONIA = 'Wallonia'
}
